module.exports = __webpack_public_path__ + "images/img_IP_3-c2b70dc574.png";